import { render } from "./MobileButton.vue?vue&type=template&id=95429e4a&scoped=true"
import script from "./MobileButton.vue?vue&type=script&lang=js"
export * from "./MobileButton.vue?vue&type=script&lang=js"

import "./MobileButton.vue?vue&type=style&index=0&id=95429e4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95429e4a"],['__file',"src/components/qywx/button/MobileButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "95429e4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('95429e4a', __exports__)) {
    api.reload('95429e4a', __exports__)
  }
  
  module.hot.accept("./MobileButton.vue?vue&type=template&id=95429e4a&scoped=true", () => {
    api.rerender('95429e4a', render)
  })

}


export default __exports__